export default __webpack_public_path__ + "static/megumi-61a1271324f987fe30879eb7e1813c92.jpg";